﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class TCAsyncLoader extends TKCustomElementFactory {
    connectedCallback(): void {
        this.registerClickListener();
    }

    private get url(): string | undefined {
        return this.getAttribute('data-tca-url') || undefined;
    }

    private get target(): string | undefined {
        return this.getAttribute('data-tca-target-area') || undefined;
    }

    private registerClickListener(): void {
        // Suche das übergeordnete Accordion
        const accordion = this.closest('tk-tabs-accordion');
        const header = accordion?.querySelector('[data-tk-accordion-head]');

        if (header) {
            this.pushListener({
                event: 'click',
                element: header,
                action: this.send.bind(this),
            });
        } else {
            console.warn('TCAsyncLoader: Kein data-tk-accordion-head gefunden.');
        }
    }

    private async send(): Promise<void> {
        if (!this.url) {
            console.warn('TCAsyncLoader: Kein data-tca-url definiert.');
            return;
        }

        fetchRequest({
            requestURL: this.url,
            resolveHandler: this.refreshContent.bind(this),
            showMessages: false,
        });
    }

    private refreshContent(response: TKResponse): void {
        if (!response?.success) return;

        if (this.target && response.dataAsHtml) {
            const targetElement = document.getElementById(this.target);
            if (targetElement) {
                targetElement.innerHTML = response.dataAsHtml;
            } else {
                console.warn(`TCAsyncLoader: Target-Element mit ID "${this.target}" nicht gefunden.`);
            }
        }
    }
}
